export default __webpack_public_path__ + "static/media/apvs-arte-4.a50030b9.webp";